import React from "react";

function ProtectedRoute({
  element,
  route,
  user,
  chimeraserv,
  components,
  fallback,
}) {
  // Authenticated route
  if (route.auth) {
    if (user.data && (user.data.type === "admin" || user.data.level === 1)) {
      return React.cloneElement(element, { user, chimeraserv, components });
    } else {
      return fallback ? React.cloneElement(fallback) : null;
    }
  }
  // Public route
  return React.cloneElement(element, { user, chimeraserv, components });
}

export default ProtectedRoute;
